import { render } from "./jtTopicCheck.vue?vue&type=template&id=e3b8d69a&scoped=true"
import script from "./jtTopicCheck.vue?vue&type=script&lang=js"
export * from "./jtTopicCheck.vue?vue&type=script&lang=js"

import "./jtTopicCheck.vue?vue&type=style&index=0&id=e3b8d69a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b8d69a"]])

export default __exports__